import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ISeasonWeek } from '../models/ISeasonWeek';
import { NflService } from '../services/nfl.service';
import { IOrg } from '../models/IOrg';
import { FormBuilder, Validators, FormGroup } from '@angular/forms'
import { AuthService } from '../account/auth.service';
import { IGameResults } from '../models/IGameResults';
import { BaseService } from '../services/base.service';
import { Http } from '@angular/http';
import { ISeason } from '../models/ISeason';
import { IWeek } from '../models/IWeek';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';
import { OrgSeasonWeekService } from '../services/orgseasonweek.service';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-nflresults',
  templateUrl: './nflresults.component.html',
  styleUrls: ['./nflresults.component.scss']
})
export class NflResultsComponent implements OnInit {

  public isRequesting: boolean = false;

  public model: IOrgSeasonWeek = { season: null, seasonType: null, week: null, org: null };

  public gameResults: IGameResults[];
  public gameSeasonResults: IGameResults[];
  public gamePlayoffSeasonResults: IGameResults[];
  //public orgUserGames: IGame[];
  //public disabled: boolean = false;
  public localTime: string;
  public serverStartDateTime: Date;
  public error: any;
  public isPlayoffs: boolean = false;


  // form: FormGroup;
  constructor(
    //private authService: AuthService,
    private nflService: NflService,
    private orgSeasonWeekService: OrgSeasonWeekService) {
  }

  public orgEvent: Subscription;
  public weekEvent: Subscription;
  public seasonEvent: Subscription;

  ngOnInit() {
    this.orgEvent = this.orgSeasonWeekService.org.subscribe(org => {
      this.model.org = org;
      this.weekEvent = this.orgSeasonWeekService.season.subscribe(season => {
        this.model.season = season;
        this.seasonEvent = this.orgSeasonWeekService.week.subscribe(week => {
          this.model.week = week;
          this.getGameResults();
          this.getPlayoffSeasonResults();
          this.getSeasonResults();

        });
      });
    });
  }

  ngOnDestroy(): void {
    this.orgEvent.unsubscribe();
    this.seasonEvent.unsubscribe();
    this.weekEvent.unsubscribe();
  }

  getGameResults() {
    this.isRequesting = true
    this.nflService.getGameResults(this.model).subscribe(result => {
      this.gameResults = result as IGameResults[];
      this.gameResults.sort((a, b) => b.points - a.points);
      this.isRequesting = false;
    });
  }



  getSeasonResults() {
    this.isRequesting = true
    this.nflService.getGameSeasonResults(this.model).subscribe(result => {
      this.gameSeasonResults = result as IGameResults[];
      this.gameSeasonResults.sort((a, b) => b.points - a.points);
      this.isRequesting = false;
    });
  }

  getPlayoffSeasonResults() {
    this.isRequesting = true
    this.nflService.getGamePlayoffSeasonResults(this.model).subscribe(result => {
      this.gamePlayoffSeasonResults = result as IGameResults[];
      this.gamePlayoffSeasonResults.sort((a, b) => b.points - a.points);
      this.isRequesting = false;
    });
  }
}






// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nflresults/nflresults.component.ts